import React from 'react';
import { Dropdown } from 'semantic-ui-react'

const prepareCompanySelection = (user) => {
    const { uuid, name, companies } = user;
    const selectedCompany = companies.filter(company => company.memberType.toUpperCase() == 'E')
    const companyOptions = [];
    for (let i = 0; i < selectedCompany.length; i++) {
        companyOptions.push({ text: selectedCompany[i].companyName, value: selectedCompany[i].companyId });
    }
    return companyOptions;
}

const ElogCompanyFilter = (props) => {
    const companyOptions = prepareCompanySelection(props.user);
    return (
        <Dropdown
            placeholder='Select Company'
            fluid
            selection
            options={companyOptions}
            value={props.selectedCompany}
            onChange={(e, { value}) => props.updateCompanySelected(value)}
        />
    );
}

export default ElogCompanyFilter;
